import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { ProblemDetails, SafetyEventClient, SafetyEventReportDTO } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const safetyEventClient = new SafetyEventClient(apiBaseUrl);

function useSubmitSafetyEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<SafetyEventReportDTO, ProblemDetails, number>({
    mutationKey: [queryKeys.SafetyEvent.Submit],
    mutationFn: (reportId: number) => safetyEventClient.submit(reportId),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useSubmitSafetyEvent;
